module.exports = __webpack_public_path__ + "img/nfl_playoffs.e773f265.png";